import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy URL redirect for the `/docs/admin-guides/:slug` shape (still
 * reachable from externally-shared in-product links). Target is
 * `/account/docs/:slug` per ADR-114 Phase 1.
 */
export function AdminDocsLegacyRedirect() {
  const { slug } = useParams<{ slug?: string }>();
  return (
    <Navigate to={slug ? `/account/docs/${slug}` : '/account/docs'} replace />
  );
}

export default AdminDocsLegacyRedirect;
